export import React = require('react');
export import models = require("app/models/requireme");
import * as rx from "rxjs";
import * as resources from "app/resources/index";
import { SelectorSimpleFactory, SelectorFiltradoFactory, SelectorEnumFactory, models } from "./logic";
import * as kea from "kea-react";
import { observeResource } from "kea-resource";
import { sucursalToString } from "app/logic/sucursal";
import { TipoReporteEstadisticasClientes } from 'app/models/reporteestadisticasclientes';
import { TipoReporte, CondicionEntrega, Orden, CondicionPago, DescripcionConcepto } from 'app/models/requireme';
import { range, formatNumber } from 'keautils';
import ret = require('kea-react/dist/grid2Base/filtros');

export const Usuario = SelectorSimpleFactory(observeResource(resources.Usuario.query, {}), x => x.IdRegistro, x => x.Nombre);
export const Guia = SelectorSimpleFactory(observeResource(resources.Guia.QueryLimit, {}), x => x.IdRegistro, x => x.Folio);
export const Factura = SelectorSimpleFactory(observeResource(resources.Factura.Query, {}), x => x.IdRegistro, x => x.SerieFolio);
export const Banco = SelectorSimpleFactory(observeResource(resources.Banco.query, {}), x => x.IdRegistro, x => x.Nombre);
export const Rol = SelectorSimpleFactory(observeResource(resources.Rol.query), x => x.IdRegistro!, x => x.Nombre!);
export const Vendedor = SelectorSimpleFactory(observeResource(resources.Vendedor.query), x => x.IdRegistro, x => x.Nombre);
export const TipoColonia = SelectorSimpleFactory(observeResource(resources.TipoColonia.query), x => x.IdRegistro, x => x.Nombre);
/////
export const Estado = SelectorSimpleFactory(observeResource(resources.Estado.query), x => x.IdRegistro, x => x.Nombre);

export const Municipio = SelectorSimpleFactory(observeResource(resources.Municipio.query), x => x.IdRegistro, x => x.Nombre);
export const MunicipioFiltroEstado = (IdEstado:number ) => 
SelectorSimpleFactory(observeResource(resources.DireccionMunicipio.queryByEstado, IdEstado), 
x => x.IdRegistro, x => ( x.NombreEstado + " - " + x.Nombre ));

export const Ciudad = SelectorSimpleFactory(observeResource(resources.Ciudad.query), x => x.IdRegistro, x => x.Nombre);
export const CiudadFiltroMunicipio = (IdMunicipio:number ) => 
SelectorSimpleFactory(observeResource(resources.DireccionCiudad.queryByMunicipio, IdMunicipio), 
x => x.IdRegistro, x => ( x.NombreMunicipio + " - " + x.Nombre ));

export const Colonias = SelectorSimpleFactory<models.Colonia, number>([], x => x.IdRegistro, x => x.Nombre);


/////
export const Turno = SelectorSimpleFactory(observeResource(resources.Turno.Query, {}), x => x.IdRegistro, x => kea.formatDate(x.FechaEntrada) + " - " + x.NombreUsuario);
export const RubroCaja = SelectorEnumFactory(models.RubroMovimientoCaja);
export const Sucursal = SelectorFiltradoFactory<models.SucursalDTO, models.FiltroSucursal>(filtro => observeResource(resources.Sucursal.query, filtro), x => x.IdRegistro, x => sucursalToString(x));
export const MatrizTarifa = SelectorSimpleFactory(observeResource(resources.MatrizTarifa.query), x => x.IdRegistro, x => x.Nombre);
export const TipoAcuse = SelectorEnumFactory(models.TipoAcuse);
export const FormaPagoNoEfectivo = SelectorEnumFactory(models.FormaPagoNoEfectivo);
export const FormaPago = SelectorEnumFactory(models.FormaPagoMovimientoCaja);
export const ContenidoPaquete = SelectorSimpleFactory(observeResource(resources.ContenidoPaquete.query), x => x.IdRegistro, x => x.Nombre);
export const ContenidoSobre = SelectorSimpleFactory(observeResource(resources.ContenidoSobre.query), x => x.IdRegistro, x => x.Nombre);
export const Tarifa = SelectorSimpleFactory(observeResource(resources.Tarifa.query), x => x.IdRegistro, x => x.Nombre);
export const DescripcionPaquete = SelectorSimpleFactory(observeResource(resources.DescripcionPaquete.DescripcionesFiltradas), x => x.IdRegistro, x => x.Nombre);
export const TipoPersona = SelectorEnumFactory(models.TipoPersona);
export const GiroEmpresa = SelectorEnumFactory(models.GiroEmpresa);
export const Clasificacion = SelectorEnumFactory(models.Clasificacion);
export const ParteTransporte = SelectorEnumFactory(models.c_ParteTransporte);
export const RequerimientoAcuse = SelectorSimpleFactory(observeResource(resources.RequerimientoAcuse.query), x => x.IdRegistro, x => x.Nombre);
export const StatusPuertaCaja = SelectorEnumFactory(models.StatusPuertaCaja);
export const Ruta = SelectorSimpleFactory(observeResource(resources.Ruta.query), x => x.IdRegistro, x => `${x.Nombre} (${x.Descripcion})`);
export const Segmento = SelectorSimpleFactory(observeResource(resources.Segmento.query), x => x.IdRegistro, x => x.Nombre);
export const StatusViajeRuta = SelectorEnumFactory(models.StatusViajeRuta);
export const StatusCargaDescarga = SelectorEnumFactory(models.StatusCargaDescarga);
export const TipoCargaDescarga = SelectorEnumFactory(models.TipoCargaDescarga);
export const TipoSeguro = SelectorEnumFactory(models.TipoSeguroGuia);
export const DiaSemana = SelectorEnumFactory(models.DiaSemana);
export const Mes = SelectorEnumFactory(models.Mes);
export const Cobrador = SelectorSimpleFactory(observeResource(resources.Cobrador.query), x => x.IdRegistro, x => x.Nombre);
export const Articulo = SelectorSimpleFactory(observeResource(resources.Articulo.query), x => x.IdRegistro, x => x.Nombre);
export const TipoFactura = SelectorEnumFactory(models.TipoFactura);
export const TipoCaptura = SelectorEnumFactory(models.TipoCaptura);
export const StatusViajeEAD = SelectorEnumFactory(models.StatusViajeEAD);
export const OrigenPolizaContable = SelectorEnumFactory(models.OrigenPolizaContable);
export const OrigenFactura = SelectorEnumFactory(models.OrigenFactura);
export const StatusFacturacion = SelectorEnumFactory(models.StatusGuiaFacturacion);
export const StatusGuia = SelectorEnumFactory(models.StatusGuia);
export const TipoPolizaContable = SelectorEnumFactory(models.TipoPolizaContable);
export const EstadoPolizaContable = SelectorEnumFactory(models.EstadoPolizaContable);
export const OrigenMovimientoSaldoUsuarioZE = SelectorEnumFactory(models.OrigenMovimientoSaldoUsuarioZE);
export const ChoferZE = SelectorSimpleFactory(observeResource(resources.ChoferZE.query), x => x.IdRegistro, x => x.NombreProveedor+"-"+ x.Nombre);
export const ChoferEAD = SelectorFiltradoFactory<models.ChoferEADDto, undefined>(() => observeResource(resources.ChoferEAD.query).map(choferes => choferes.filter(x => !x.Deshabilitado)), x => x.IdRegistro, x => x.NombreSucursal + " - " + x.Nombre);
export const ChoferRuta = SelectorFiltradoFactory<models.ChoferRutaDto, undefined>(() => observeResource(resources.ChoferRuta.query).map(choferes => choferes.filter(x => !x.Deshabilitado)), x => x.IdRegistro, x => x.Nombre);
export const CamionEAD = SelectorSimpleFactory(observeResource(resources.CamionEAD.query), x => x.IdRegistro, x => x.NombreSucursal + " - " + x.Nombre);
export const RutaEAD = SelectorSimpleFactory(observeResource(resources.RutaEAD.Query, {}), x => x.IdRegistro, x => x.NombreSucursal + " - " + x.Nombre);
export const TarifaPagoChofer = SelectorSimpleFactory(observeResource(resources.TarifaPagoChofer.query), x => x.IdRegistro, x => x.Nombre);
export const TarifaZEPrecio = SelectorSimpleFactory(observeResource(resources.TarifaPrecioZE.query), x => x.IdRegistro, x => x.Nombre);
export const UsuarioZE = SelectorSimpleFactory(observeResource(resources.UsuarioZE.Query, {}), x => x.IdRegistro, x => x.Nombre);
export const UsuarioZEByUserRol = SelectorSimpleFactory(observeResource(resources.UsuarioZE.QueryByUserRol, {}), x => x.IdRegistro, x => x.Nombre);
export const VehiculoZE = SelectorSimpleFactory(observeResource(resources.VehiculoZE.query), x => x.IdRegistro, x => x.Placas);
export const ZonaExtendida = SelectorSimpleFactory(observeResource(resources.ZonaExtendida.query, {}), x => x.IdRegistro, x => x.Nombre);
export const TarifaPP = SelectorSimpleFactory(observeResource(resources.TarifaPP.query), x => x.IdRegistro, x => x.Nombre);
export const UsuarioApi = SelectorSimpleFactory(observeResource(resources.UsuarioApi.query), x => x.IdRegistro, x => x.Nombre);
export const TipoReporteEstadisticasClientesSelector = SelectorEnumFactory(TipoReporteEstadisticasClientes);
export const TipoReporteGuiasEnviadasRecibidas = SelectorEnumFactory(TipoReporte);
export const CondicionEntregaReporteGuiasEnviadasRecibidas = SelectorEnumFactory(CondicionEntrega);
export const OrdenReporteGuiasEnviadasRecibidas = SelectorEnumFactory(Orden);
export const CondicionPagoSelector = SelectorEnumFactory(CondicionPago);
export const DescripcionConceptoSelector = SelectorEnumFactory(DescripcionConcepto);
export const BitacoraRADStatusSelector = SelectorEnumFactory(models.StatusBitacoraRad);
export const BitacoraRADTipoSelector = SelectorEnumFactory(models.HorarioRad);


export const CodigoRegimenFiscal = SelectorEnumFactory(models.CodigoRegimenFiscal);

//////////////////////////SAT
export const CpSatSubTipoRem = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatSubTipoRem, {}), 
x => x.IdRegistro, x => ( x.Clave + " - " + x.Descripcion ));

export const CpSatClaveProd = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatClaveProd, {}), 
x => x.IdRegistro, x => ( x.Clave + " - " + x.Descripcion ));

export const CpSatTipoEmbalajeSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatTipoEmbalajeQuery, {}), 
x => x.IdRegistro, x => ( x.Clave + " - " + x.Descripcion ));

export const CpSatConfigAutotransporteSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatConfigAutotransporteQuery, {}), 
x => x.IdRegistro, x => ( x.Clave + " - " + x.Descripcion ));

export const CpSatTipoPermisoSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatTipoPermisoQuery, {}), 
x => x.IdRegistro, x => ( x.Clave + " - " + x.Descripcion ));


export const CpSatMunicipioSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatMunicipioQuery, {}), 
x => x.IdRegistro, x => ( x.ClaveEstado + " - " + x.Descripcion ));

export const CpSatLocalidadSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatLocalidadQuery, {}), 
x => x.IdRegistro, x => ( x.ClaveEstado + " - " + x.Descripcion ));

export const CpSatColoniaSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatColoniaQuery, {}), 
x => x.IdRegistro, x => ( x.CodigoPostal + " - " + x.Nombre ));


//export const ColoniaSelector = SelectorSimpleFactory(observeResource(resources.Colonia.ObtenerCodPostalInfo, {}), 
//x => x.IdRegistro, x => ( x.CodigoPostal + " - " + x.Nombre ));


///////////////////////Nuevos sat///////////////////////
export const CpSatEstadoSelector = SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatEstadoQuery, {}), 
x => x.IdRegistro, x => ( x.Clave ));

export const CpSatLocalidadByMunicipioSelector = (idMunicipio:number ) => 
SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatLocalidadByClaveMunicipioQuery, idMunicipio), 
x => x.IdRegistro, x => ( x.ClaveEstado + " - " + x.Descripcion ));

export const CpSatColoniaByMunicipioSelector = (idMunicipio:number ) =>
 SelectorSimpleFactory(observeResource(resources.CatalogosSAT.CpSatColoniaByClaveMunicipioQuery, idMunicipio), 
x => x.IdRegistro, x => ( x.CodigoPostal + " - " + x.Nombre ));

///////////////////////Nuevos sat///////////////////////

//////////////////////////SAT

export const VehiculoZE2 = (id:number ) => SelectorSimpleFactory(observeResource(resources.VehiculoZE2.QueryById,id), 
x => x.IdRegistro, x => ( x.Marca + " - " + x.Placas ));

export const VehiculoByChoferId = (id:number ) => SelectorSimpleFactory(observeResource(resources.VehiculoZE2.QueryByChoferId,id), 
x => x.IdRegistro, x => ( x.Marca + " - " + x.Placas ));

export const ChoferZEByUserZE = (idUsuarioZE:number ) => SelectorSimpleFactory(observeResource(resources.ChoferZE.QueryById,idUsuarioZE), 
x => x.IdRegistro, x => ( x.Nombre));

export const ChoferEADBySucursal = (idSucursal:number ) => SelectorSimpleFactory(observeResource(resources.ChoferEAD.QueryByIdSucursal,idSucursal), 
x => x.IdRegistro, x => ( x.NombreSucursal+" - "+x.Nombre));

export const CamionEADBySucursal = (idSucursal:number ) => SelectorSimpleFactory(observeResource(resources.ChoferEAD.QueryCamionByIdSucursal,idSucursal), 
x => x.IdRegistro, x => ( x.NombreSucursal+" - "+x.Nombre));

export const formatMinutes = (x: number) => `${formatNumber(Math.floor(x / 60),2 )}:${formatNumber(x % 60, 2)}`;

export const CanalEntradaText = (x: number) => 
{   var c="";
    switch (x) {
        case 0: c="Teléfono"; break;
        case 1: c="Whatsapp"; break;
        case 2: c="Correo"; break;
        case 3: c="Instagram"; break;
        case 4: c="Solicitud interna"; break;
    }
     return c
};

export const QuienSolicitaText = (x: number) => 
{   var c="";
    switch (x) {
        case 0: c="Cliente origen"; break;
        case 1: c="Funcionario de sucursal origen"; break;
        case 2: c="Cliente destino"; break;
        case 3: c="Funcionario de sucursal destino"; break;
    }
     return c
};

const horas_bitacora = range(390, 15*2, 30).map(x => ({
    value: x,
    label: formatMinutes(x)
}));

const horas = range(0, 24*2, 30).map(x => ({
    value: x,
    label: formatMinutes(x)
}));

export const SelectorHora = SelectorSimpleFactory(horas, x => x.value, x => x.label);

export const SelectorHoraBitacora = SelectorSimpleFactory(horas_bitacora, x => x.value, x => x.label);

export const SiNo = SelectorSimpleFactory([
    { label: "Si", value: true },
    { label: "No", value: false }
], x => x.value, x => x.label);

export const AumentoDisminucion = SelectorSimpleFactory([
    { label: "Aumento", value: true },
    { label: "Disminucion", value: false }
], x => x.value, x => x.label);

export const EmpresaLogistica = SelectorSimpleFactory([
    { label: "Logistica", value: true },
    { label: "Paqueteria", value: false }
], x => x.value, x => x.label);

export const SiNoVacias = SelectorSimpleFactory([
    { label: "Si", value: "Si" },
    { label: "No", value: "No" },
    { label: "Vacías", value: "Vacías" }
], x => x.value, x => x.label);

export const BitacoraRADCanalEntrada = SelectorSimpleFactory([
    { label: "Teléfono", value: models.CanalEntrada.Teléfono,  },
    { label: "Whatsapp", value: models.CanalEntrada.Whatsapp },
    { label: "Correo", value: models.CanalEntrada.Correo },
    { label: "Instagram", value: models.CanalEntrada.Instagram },
    { label: "Solicitud interna", value: models.CanalEntrada.Solicitud_interna },
], x => x.value, x => x.label);

export const BitacoraRADQuienSolicita = SelectorSimpleFactory([
    { label: "Cliente origen", value: models.QuienSolicita.Cliente_origen },
    { label: "Funcionario de sucursal origen", value: models.QuienSolicita.Gerente_de_sucursal_origen },
    { label: "Cliente destino", value: models.QuienSolicita.Cliente_destino },
    { label: "Funcionario de sucursal destino", value: models.QuienSolicita.Gerente_de_sucursal_destino },
], x => x.value, x => x.label);

export const VisualizarPaquetes = SelectorSimpleFactory([
    { label: "Utilizada", value: 1 },
    { label: "NoUtilizada", value: 2 }


], x => x.value, x => x.label);


// WEBPACK FOOTER //
// ./app/features/selectores/simples.tsx